import { sortNoSort } from "@nvon/baseline";
import Fuse from "fuse.js";
import { useMemo } from "react";
import { sortByScore } from "../helpers/sortByScore.js";
export var FuseSearchResultType;

(function (FuseSearchResultType) {
  /**
   * Return the type of entry that you passed in, filtered and optionally sorted by score.
   */
  FuseSearchResultType["PlainEntries"] = "plainEntries";
  /**
   * Return the FuseResult type if you need specific information from it.
   */

  FuseSearchResultType["FuseResults"] = "FuseResults";
})(FuseSearchResultType || (FuseSearchResultType = {}));
/**
 * Search a list of entries with a search string.
 * If scoring  is enabled in the searchOptions, results are ordered by score.
 *
 * 🚨 If you pass in an empty search string, the resulting array will be empty.
 *
 * @see https://fusejs.io/
 */


export var useFuseSearch = function useFuseSearch(_ref) {
  var list = _ref.list,
      searchOptions = _ref.searchOptions,
      searchTerm = _ref.searchTerm,
      resultType = _ref.resultType;

  /**
   * The fuse instance which contains the list.
   *
   * Caution: a new instance it created each time the list or the search option changes.
   */
  var searchObject = useMemo(function () {
    return new Fuse(list, searchOptions);
  }, [list, searchOptions]);
  /**
   * This defined how the results will be sorted.
   */

  var sortingFunction = useMemo(function () {
    return searchOptions.includeScore ? sortByScore : sortNoSort;
  }, [searchOptions.includeScore]);
  /**
   * Finally, the results are mapped to the expected ResultType.
   */

  var mapper = useMemo(function () {
    return resultType === FuseSearchResultType.FuseResults ? function (res) {
      return res;
    } : function (res) {
      return res.item;
    };
  }, [resultType]);
  /**
   * The result: a list that is
   *   - shrinked down via search
   *   - sorted according to score
   *   - mapped to contain either the plain data, or Fuse objects.
   */

  return useMemo(function () {
    return searchObject.search(searchTerm).sort(sortingFunction).map(mapper);
  }, [mapper, searchObject, searchTerm, sortingFunction]);
};